import type { CSSProperties } from 'react';

/**
 * Fill colour of a text label drawn over image pixels. White rather than
 * the annotation's own colour: see {@link OVERLAY_LABEL_TEXT_STYLE}.
 */
export const OVERLAY_LABEL_FILL = '#ffffff';

/**
 * Outline for a text label drawn over image pixels.
 *
 * A viewport label sits on whatever the colormap paints, and the PET maps
 * between them cover the whole range: Invert Gray starts at white, every
 * other map starts at black, and Rainbow, Rainbow 2 and Spectrum pass
 * through fully saturated blues, purples, pinks and yellows on the way up.
 * No single hue is legible against all of that — magenta text vanishes
 * into Rainbow 2's purples and reads poorly on Invert Gray's white end.
 *
 * Contrast is therefore carried by LUMINANCE rather than hue: a white
 * glyph with a near-black outline separates from a light background by
 * its outline and from a dark one by its fill, and from a saturated hue
 * by both. This replaces a blurred `text-shadow`, which glows rather than
 * outlining and leaves no crisp edge on a mid-tone.
 *
 * `paint-order: stroke` draws the outline BEHIND the fill, so the stroke
 * thickens the letterform outward instead of eating into it; the round
 * join keeps it from spiking at sharp corners.
 */
export const OVERLAY_LABEL_TEXT_STYLE: CSSProperties = {
    paintOrder: 'stroke',
    stroke: 'rgba(0, 0, 0, 0.85)',
    strokeWidth: 3,
    strokeLinejoin: 'round',
    userSelect: 'none',
    pointerEvents: 'none',
};
